export interface Property {
  id: string;
  name: string;
  location: string;
  image: string;
  alt: string;
  rating: number;
  reviews: number;
  price: number;
  currency: string;
  tag?: string;
  tagColor?: string;
}

export const FEATURED_PROPERTIES: Property[] = [
  {
    id: 'prop-1',
    name: 'El Aurassi Hotel',
    location: 'Algiers, Telemly Hill',
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_11b4952b7-1775932741332.png',
    alt: 'Luxury hotel overlooking Algiers bay with panoramic Mediterranean views',
    rating: 4.8,
    reviews: 312,
    price: 12500,
    currency: 'DZD',
    tag: 'Top Rated',
    tagColor: 'bg-primary-500',
  },
  {
    id: 'prop-2',
    name: 'Sheraton Oran Hotel',
    location: 'Oran, Seafront',
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_19791a7de-1773568773193.png',
    alt: 'Modern beachfront hotel in Oran with swimming pool and sea views',
    rating: 4.6,
    reviews: 198,
    price: 9800,
    currency: 'DZD',
    tag: 'Sea View',
    tagColor: 'bg-accent-500',
  },
  {
    id: 'prop-3',
    name: 'Cirta Hotel Constantine',
    location: 'Constantine, Old City',
    image: 'https://images.unsplash.com/photo-1721429432323-3cb869810052',
    alt: 'Historic hotel perched above the gorges of Constantine with bridge views',
    rating: 4.5,
    reviews: 145,
    price: 7200,
    currency: 'DZD',
    tag: 'Heritage',
    tagColor: 'bg-sand-300',
  },
  {
    id: 'prop-4',
    name: 'Tamanrasset Desert Lodge',
    location: 'Tamanrasset, Hoggar',
    image: 'https://images.unsplash.com/photo-1706622618242-b026f266057b',
    alt: 'Luxury desert lodge surrounded by Saharan dunes and Hoggar mountains at sunset',
    rating: 4.9,
    reviews: 87,
    price: 15000,
    currency: 'DZD',
    tag: 'Unique Stay',
    tagColor: 'bg-primary-500',
  },
];
